import { take, call, put, fork, all } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getShopLocaleListFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload: { filter }, next } = yield take('GET_SHOP_LOCALE_LIST');

		try {
			const response = yield call(fetchApi, `Locales?filter=${JSON.stringify(filter)}`);

			if (response && !response.error) {
				yield put({ type: 'GET_SHOP_LOCALE_LIST_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

// function* getShopLocaleListByStoreIdFlow() {
// 	const INFINITE = true;

// 	while (INFINITE) {
// 		const { payload, next } = yield take('GET_SHOP_LOCALE_LIST_BY_STORE_ID');

// 		try {
// 			const response = yield call(fetchApi, `Locales/getShopLocaleListByStoreId`, { storeId: payload.storeId });

// 			if (response && !response.error) {
// 				if (next && typeof next === 'function') {
// 					next(response);
// 				}
// 			}
// 		} catch (err) {
// 			yield put({ type: 'REQUEST_ERROR', payload: err });
// 		}
// 	}
// }

function* addShopLocaleFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('ADD_SHOP_LOCALE');

		const accountId = payload.accountId;
		const data = payload.formData;

		try {
			const response = yield call(fetchApi, `Accounts/${accountId}/locales`, data, { method: 'POST' });

			if (response && !response.error) {
				yield put({ type: 'ADD_SHOP_LOCALE_LIST_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* editShopLocaleFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('EDIT_SHOP_LOCALE');

		const shopLocaleId = payload.id;
		const data = payload.formData;

		try {
			const response = yield call(fetchApi, `Locales/${shopLocaleId}`, data, { method: 'PATCH' });

			if (response && !response.error) {
				yield put({ type: 'EDIT_SHOP_LOCALE_LIST_SUCCESS', payload: response });
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

function* deleteShopLocaleFlow() {
	const INFINITE = true;

	while (INFINITE) {
		const { payload, next } = yield take('DELETE_SHOP_LOCALE');

		try {
			const reqs = [];
			payload.forEach((el) => {
				reqs.push(call(fetchApi, `Locales/${el.id}`, {}, { method: 'DELETE' }));
			});

			const responses = yield all(reqs);
			if (responses && responses[0] && !responses[0].error) {
				if (next && typeof next === 'function') {
					next();
				}
			}
		} catch (err) {
			yield put({ type: 'REQUEST_ERROR', payload: err });
		}
	}
}

export default function* shopLocaleFlow() {
	yield fork(getShopLocaleListFlow);
	// yield fork(getShopLocaleListByStoreIdFlow);
	yield fork(addShopLocaleFlow);
	yield fork(editShopLocaleFlow);
	yield fork(deleteShopLocaleFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/shop-locale/saga/index.js